import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

/**
 * Filter by the calling customer's in_app_users audience — wallets pushed via
 * the data sources users API. Resolves server-side to a terms_lookup against
 * console-accounts/<accountId>.in_app_users, where accountId is taken from the
 * x-account header that ds_proxy injects on every authenticated request.
 *
 * No user input: the customer's identity comes from the request auth, not the
 * filter payload.
 */
const InAppUsersSection = ({ onUpdate, boostInput = false, fieldName = 'wallet_address' }) => {
  const [boost, setBoost] = useState(1);

  const handleAction = (actionType) => {
    const updateData = {
      action: actionType,
      filter: 'in_app_users',
      field: fieldName,
    };
    if (boostInput) updateData.boost = boost;
    onUpdate(updateData);
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
        Matches the wallets your account has pushed via the data sources users
        API. Resolved server-side from your API key — no input needed.
      </Typography>

      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button variant="contained" color="primary" onClick={() => handleAction('include')}>
          <AddIcon />
        </Button>
        {boostInput && (
          <Button variant="contained" color="success" onClick={() => handleAction('boost')}>
            <TrendingUpIcon />
          </Button>
        )}
        <Button variant="contained" color="error" onClick={() => handleAction('exclude')}>
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default InAppUsersSection;
